import React from 'react'
import { Logo } from './icons/Logo'
import { PrimeLogo } from './icons/PrimeLogo'
import { PromoLogo } from './icons/PromoLogo'
import styles from './styles.module.css'

interface ILogoWide {
  isPrime: boolean
  isPromo: boolean
  isResponsive: boolean
}

const LogoWide = ({ isPrime = false, isPromo = false, isResponsive = false }: ILogoWide) => {
  let className = styles.brandLogo
  if (isResponsive) {
    className = styles.responsiveBrandLogo
  }

  if (isPrime) return <PrimeLogo className={className} />
  if (isPromo) return <PromoLogo className={className} />
  return <Logo className={className} />
}

export default LogoWide
